import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ThemeProvider } from 'styled-components';
import 'semantic-ui-css/semantic.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import maintenanceService from './services/maintenance/maintenance.service';

import Loading from './components/common/Loading';
import {
  LoadingProvider,
  useLoading,
} from './components/agent/Context/LoadingContext';
import { routes, routesMaintenance } from './routes';
import {
  common,
  contrast,
  dark,
  gray,
  light,
} from './styles/GlobalStyle/themes';

export function App() {
  const [maintenanceMode, setMaintenanceMode] = useState<boolean>(false);
  const { isLoading, setIsLoading } = useLoading();

  const googleTag: string = process.env.REACT_APP_GOOGLE_TAG || '';
  ReactGA.initialize(googleTag);

  useEffect(() => {
    setIsLoading(true);
    maintenanceService
      .checkMaintenance()
      .then((data) => {
        if (data.result) {
          if (data.data.server_under_maintenance) {
            setMaintenanceMode(true);
          }
        }
      })
      .catch((error: Error) => {
        console.error(error.name + ':' + error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const themes = {
    dark: dark,
    light: light,
    contrast: contrast,
    gray: gray,
  };

  const userInfoTheme = localStorage.getItem('dataStudent');
  const userData = JSON.parse(String(userInfoTheme));
  let selectedTheme: 'dark' | 'light' | 'contrast' | 'gray' = 'light';
  let selectedFontSize: 'xSmall' | 'small' | 'normal' | 'large' | 'xLarge' =
    'normal';
  useEffect(() => {
    if (userData) {
      if (
        userData.preferences?.theme === 'dark' ||
        userData.preferences?.theme === 'light' ||
        userData.preferences?.theme === 'contrast' ||
        userData.preferences?.theme === 'gray'
      ) {
        selectedTheme = userData.preferences.theme;
      }
      if (userData.preferences?.fontSize) {
        selectedFontSize = userData.preferences.fontSize;
      }
    }
  }, []);

  if (isLoading) {
    return (
      <ThemeProvider
        theme={{
          ...common,
          fontSizeType: selectedFontSize,
          ...themes[selectedTheme],
        }}
      >
        <Loading />
      </ThemeProvider>
    );
  }
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isLoading]);

  return (
    <ThemeProvider
      theme={{
        ...common,
        fontSizeType: selectedFontSize,
        ...themes[selectedTheme],
      }}
    >
      <LoadingProvider>
        {maintenanceMode ? (
          <RouterProvider router={routesMaintenance} />
        ) : (
          <RouterProvider router={routes} />
        )}
      </LoadingProvider>
    </ThemeProvider>
  );
}